import "./BradenScore.scss";
import { Header } from "../Header/Header";
import SideBar from "../SideBar/Sidebar";
import redRating from "../../common/icons/svg/red-rating.svg";
import yellowRating from "../../common/icons/svg/yellow-rating.svg";
import greenRating from "../../common/icons/svg/green-rating.svg";
import React, { useState, useEffect } from 'react';

function BradenScore(props) {
    const [sensoryPerceptionRating, setSensoryPerception] = useState(0);
    const [moisureRating, setMoisureRating] = useState(0);
    const [activityRating, setActivityRating] = useState(0);
    const [mobilityRating, setMobilityRating] = useState(0);
    const [nutritionRating, setNutritionRating] = useState(0);
    const [frictionShearRating, setFrictionShearRating] = useState(0);
    const [totalScore, setTotalScore] = useState(0);

    const handleSensoryPerceptionRadio = (rating) => {
        setSensoryPerception(rating);
    }
    const handleMoistureRadio = (rating) => {
        setMoisureRating(rating);
    }
    const handleActivityRadio = (rating) => {
        setActivityRating(rating);
    }
    const handleMobilityRadio = (rating) => {
        setMobilityRating(rating);
    }
    const handleNutritionRadio = (rating) => {
        setNutritionRating(rating);
    }
    const handleFrictionShearRadio = (rating) => {
        setFrictionShearRating(rating);
    }
    useEffect(() => {
        setTotalScore(sensoryPerceptionRating +
            moisureRating +
            activityRating +
            mobilityRating +
            nutritionRating +
            frictionShearRating);

    }, [sensoryPerceptionRating,
        moisureRating,
        activityRating,
        mobilityRating,
        nutritionRating,
        frictionShearRating])

    return (
        <div className="braden-score-container">
            <Header
            // handleWardChange={(item) => setSelectedWard(item)}
            // wardOption={wardOption}
            // selectedWard={selectedWard} 
            />
            <SideBar />
            <div className="braden-score-body">
                <div className="score-top-header">
                    <div className="braden-heading-container">
                        <span className="heading">Braden Score</span>
                        <div className={`show-score
                                        ${(totalScore <= 12) && (totalScore >= 9) ? "red-score" : ""} 
                                        ${(totalScore <= 18) && (totalScore >= 13) ? "yellow-score" : ""}
                                        ${(totalScore <= 23) && (totalScore >= 19) ? "green-score" : ""}
                                         `}>Score: {totalScore}</div>
                    </div>
                    <div className="braden-rating-container">
                        <div className="common-rating-cls">
                            <img className="rating-color" src={redRating} />
                            <span>Severe: &le;12</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={yellowRating} />
                            <span>Moderate: 13-18</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={greenRating} />
                            <span>Safe: 19-23</span>
                        </div>
                    </div>
                </div>
                <div className="braden-mcq-container">
                    <div className="common-mcq">
                        <div className="mcq-heading">Sensory perception</div>
                        <div className="mcq-score">{sensoryPerceptionRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="no-impairment-perception" name="sensory-perception" onClick={() => handleSensoryPerceptionRadio(4)} />
                                <label htmlFor="no-impairment-perception">No Impairment (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="slightly-limited-perception" name="sensory-perception" onClick={() => handleSensoryPerceptionRadio(3)} />
                                <label htmlFor="slightly-limited-perception">Slightly Limited (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="very-limited-perception" name="sensory-perception" onClick={() => handleSensoryPerceptionRadio(2)} />
                                <label htmlFor="very-limited-perception">Very Limited (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="completely-limited-perception" name="sensory-perception" onClick={() => handleSensoryPerceptionRadio(1)} />
                                <label htmlFor="completely-limited-perception">Completely Limited (+1)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Moisture</div>
                        <div className="mcq-score">{moisureRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="rarely-moist" name="moisture" onClick={() => handleMoistureRadio(4)} />
                                <label htmlFor="rarely-moist">Rarely Moist (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="occasionally-moist" name="moisture" onClick={() => handleMoistureRadio(3)} />
                                <label htmlFor="occasionally-moist">Ocassionally Moist (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="very-moist" name="moisture" onClick={() => handleMoistureRadio(2)} />
                                <label htmlFor="very-moist">Very Moist (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="constantly-moist" name="moisture" onClick={() => handleMoistureRadio(1)} />
                                <label htmlFor="constantly-moist">Constantly Moist (+1)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Activity</div>
                        <div className="mcq-score">{activityRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="walks-frequently" name="activity" onClick={() => handleActivityRadio(4)} />
                                <label htmlFor="walks-frequently">Walks Frequently (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="walks-occasionally" name="activity" onClick={() => handleActivityRadio(3)} />
                                <label htmlFor="walks-occasionally">Walks Ocassionally (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="chair-fast" name="activity" onClick={() => handleActivityRadio(2)} />
                                <label htmlFor="chair-fast">Chairfast (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="besfast" name="activity" onClick={() => handleActivityRadio(1)} />
                                <label htmlFor="besfast">Bedfast (+1)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Mobility</div>
                        <div className="mcq-score">{mobilityRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="no-limit-mobility" name="mobility" onClick={() => handleMobilityRadio(4)} />
                                <label htmlFor="no-limit-mobility">No Limitation (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="slightly-limited-mobility" name="mobility" onClick={() => handleMobilityRadio(3)} />
                                <label htmlFor="slightly-limited-mobility">Slightly Limited (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="very-limited-mobility" name="mobility" onClick={() => handleMobilityRadio(2)} />
                                <label htmlFor="very-limited-mobility">Very Limited (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="completely-limited-mobility" name="mobility" onClick={() => handleMobilityRadio(1)} />
                                <label htmlFor="completely-limited-mobility">Completely Limited (+1)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Nutrition</div>
                        <div className="mcq-score">{nutritionRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="excellent-nutrition" name="nutrition" onClick={() => handleNutritionRadio(4)} />
                                <label htmlFor="excellent-nutrition">Excellent(+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="adequate-nutrition" name="nutrition" onClick={() => handleNutritionRadio(3)} />
                                <label htmlFor="adequate-nutrition">Adequate (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="probably-inadequate-nutrition" name="nutrition" onClick={() => handleNutritionRadio(2)} />
                                <label htmlFor="probably-inadequate-nutrition">Probably Inadequate(+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="very-poor-nutrition" name="nutrition" onClick={() => handleNutritionRadio(1)} />
                                <label htmlFor="very-poor-nutrition">Very Poor (+1)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Friction and Shear</div>
                        <div className="mcq-score">{frictionShearRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="no-app-prob" name="friction-shear" onClick={() => handleFrictionShearRadio(3)} />
                                <label htmlFor="no-app-prob">No Apparent Problem (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="potential-prob" name="friction-shear" onClick={() => handleFrictionShearRadio(2)} />
                                <label htmlFor="potential-prob">Potential Problem (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="problem" name="friction-shear" onClick={() => handleFrictionShearRadio(1)} />
                                <label htmlFor="problem">Problem(+1)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="braden-total-rating-container">
                    <span>Total Braden Score</span>
                    <div className="total-rating">{totalScore}</div>
                </div>
                <div className="submit-btn-container">
                    <div className="submit-btn" onClick={() => props.handleSubmitClick(totalScore)}>Submit</div>
                </div>


            </div>
        </div >
    )
}
export default BradenScore;
